// extracted by mini-css-extract-plugin
export default {"home":"NewComplaints_home__hZDJT","home2":"NewComplaints_home2__LOagL","main":"NewComplaints_main__rRW5F","brmedium":"NewComplaints_brmedium__2RsNw"};